<template>
  <div class="layout-authentication">
    <header>
      <f-box 
        size="small"
        fill
      >
        <img src="@assets/images/logo.png" alt="Logo">
      </f-box>
    </header>
    
    <div class="layout-authentication-content is-grid">
      <div class="is-col-4"></div>

      <div class="is-col-4">
        <router-view></router-view>
      </div>

      <div class="is-col-4"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .layout-authentication {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 100vw;
    min-height: 100vh;

    header {
      margin: 3rem 0rem;
      img {
        max-height: 3rem;
        max-width: 3rem; 
      }
    }

    &-content {
      width: 100%;
      max-width: 1200px;
    }
  }
</style>